import type { Company } from "@generated/types"
import type { Selectable } from "kysely"
import { forceNonEmpty } from "~/utils/tsUtils"

export type OptionType = { value: string; label: string }

export const serviceLevelOptions = forceNonEmpty([
  // DON*T UPDATE ZFACTORS SINCE  THEY ARE USED AS  LOOKUP VALUES, IF YOU DO MAKE A MIGRATION
  { label: "75%", zfactor: 0.68 },
  { label: "85%", zfactor: 1.04 },
  { label: "87%", zfactor: 1.13 },
  { label: "90%", zfactor: 1.3 },
  { label: "92%", zfactor: 1.4 },
  { label: "94%", zfactor: 1.56 },
  { label: "95%", zfactor: 1.6 },
  { label: "96%", zfactor: 1.76 },
  { label: "98%", zfactor: 2.0 },
  { label: "99%", zfactor: 2.3 },
])

export const lifecycleStatusValues = ["active", "phasingOut", "phasedOut"] as const
export type LifecycleStatusValue = (typeof lifecycleStatusValues)[number]

export const currencyOptions: OptionType[] = [
  { value: "DKK", label: "DKK" },
  { value: "EUR", label: "EUR" },
  { value: "USD", label: "USD" },
  { value: "SEK", label: "SEK" },
  { value: "NOK", label: "NOK" },
  { value: "GBP", label: "GBP" },
]

export const fabricConsumptionUnitOptions: {
  value: Selectable<Company>["fabricConsumptionUnit"]
  label: string
}[] = [
  { value: "m", label: "Meters (m)" },
  { value: "kg", label: "Kilograms (kg)" },
  { value: "mixed", label: "Mixed (no unit shown)" },
]

export const bufferOptions: OptionType[] = [
  { value: "serviceLevel", label: "Service level" },
  { value: "weekCover", label: "Week cover" },
  { value: "noSafetyStock", label: "No safety stock" },
]

export const productTypeOptions = forceNonEmpty([
  { label: "NOOS", value: "noos" },
  { label: "Fashion", value: "fashion" },
])

export const userRoleOptions: OptionType[] = [
  { label: "Admin", value: "admin" },
  { label: "User", value: "user" },
  { label: "Read only", value: "read_only" },
]
